import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { TEMPLATES_MAP } from 'components/templates'

import { MQTT_COMMAND } from 'constants/appConstants'
import { useMqttClient } from 'hooks/useMqttClient'
import useScreenContent from 'hooks/useScreenContent'

import View from './view'

const IdleContent = ({ screenSelected, setContentAttributes }) => {
  const { mqttClient } = useMqttClient()

  const availableContentTypes = Object.keys(TEMPLATES_MAP)

  const { content: screenContent, refetch } = useScreenContent(availableContentTypes, screenSelected)

  const [playListOrder, setPlayListOrder] = useState([])
  const [currentPlaylist, setCurrentPlaylist] = useState([])
  const [otherContent, setOtherContent] = useState([])
  const processMessage = (topic, message) => {
    const { command } = JSON.parse(message.toString())
    if (command !== MQTT_COMMAND.REFRESH) {
      return
    }

    refetch()
  }

  const getCurrentTime = () => {
    const now = new Date()
    return now.toTimeString().split(' ')[0]
  }

  const timeToSeconds = time => {
    const [hours, minutes, seconds] = time.split(':').map(Number)
    return hours * 3600 + minutes * 60 + seconds
  }

  useEffect(() => {
    if (screenContent) {
      setOtherContent([])
      setCurrentPlaylist([])
      screenContent.forEach(element => {
        if (element.contentType === 'playlists') {
          const sortedPlaylists = [element].sort((a, b) => timeToSeconds(a.timeStart) - timeToSeconds(b.timeStart))
          setPlayListOrder(sortedPlaylists)
          setCurrentPlaylist(getCurrentPlaylist(sortedPlaylists))
        } else {
          setPlayListOrder([])
          setOtherContent(otherContent => [...otherContent, element])
        }
      })
    }
  }, [screenContent])

  const getCurrentPlaylist = playlists => {
    const currentTime = timeToSeconds(getCurrentTime())

    for (let i = playlists.length - 1; i >= 0; i--) {
      const playlistStart = timeToSeconds(playlists[i].timeStart)
      if (currentTime >= playlistStart) {
        return playlists[i]
      }
    }

    return playlists[playlists.length - 1]
  }

  const extractPlaylistContents = playlist =>
    playlist?.contents?.map(content => ({
      ...content,
      contentType: playlist?.contentType,
    }))

  useEffect(() => {
    const interval = setInterval(() => {
      const newContent = getCurrentPlaylist(playListOrder)

      if (newContent?.documentId !== currentPlaylist?.documentId) {
        setCurrentPlaylist(newContent)
      }
    }, 60000)

    return () => clearInterval(interval)
  }, [currentPlaylist])

  useEffect(() => {
    if (!mqttClient) {
      return
    }

    mqttClient.on('message', processMessage)
    return () => mqttClient.removeListener('message', processMessage)
  }, [mqttClient])

  return currentPlaylist?.documentId ? (
    <View screenContent={extractPlaylistContents(currentPlaylist)} setContentAttributes={setContentAttributes} />
  ) : (
    <View screenContent={otherContent} setContentAttributes={setContentAttributes} />
  )
}

IdleContent.defaultProps = {
  screenSelected: '',
  setContentAttributes: () => {},
}

IdleContent.propTypes = {
  screenSelected: PropTypes.string,
  setContentAttributes: PropTypes.func,
}

export default IdleContent
